import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetectionDetailComponent } from './detection-detail.component';
import { BlobToSafeUrl } from '../../../../../../pipes/blob-to-safe-url/blob-to-safe-url.module';
import { FacePipeModule } from '../../../../../people/pipes/face-pipe/face-pipe.module';
import { ImageCroppedModule } from '../../../../../../components/image-cropped/image-cropped.module';
import { DetectionBboxPipeModule } from '../../../../pipes/detection-bbox-pipe/detection-bbox-pipe.module';
import { ConfidenceBadgeModule } from '../../../../../../components/confidence-badge/confidence-badge.module';

@NgModule({
  declarations: [DetectionDetailComponent],
  imports: [
    CommonModule,
    BlobToSafeUrl,
    FacePipeModule,
    ImageCroppedModule,
    DetectionBboxPipeModule,
    ConfidenceBadgeModule,
  ],
  exports: [DetectionDetailComponent],
})
export class DetectionDetailModule {}
